export default __webpack_public_path__ + "static/media/01.5e1c5fc5.png";